import React from 'react'

function TemplateTwo() {
  return (
    <div>TemplateTwo</div>
  )
}

export default TemplateTwo